import {useSettingStore} from "~/stores/setting";
import {useRoute, useRouter} from "vue-router";
import {computed} from "vue";

export function useGoTo() {
    const settingStore = useSettingStore();
    const router = useRouter();
    const route = useRoute();
    const isMobile = computed(() => settingStore.isMobile);

    function goHome(routeQuery) {
        if (route.path.includes('/space/')) {
            router.push({path: '/'});
        } else {
            // sass 頁面會有 adminInfo，要回獨立頁面
            const adminInfo = useState<Record<string, any>>('adminInfo', () => ({}));
            const admin_domain = adminInfo.value?.admin_domain;
            if (admin_domain) {
                window.location.href = `https://${admin_domain}`;
            } else {
                router.push({path: settingStore.getHomeRouter, query: routeQuery});
            }
        }


        /*navigateTo({
            path: settingStore.getHomeRouter,
            query: routeQuery
        })*/
    }

    function go(url) {
        router.push({path: url, query: route.query})
    }

    function goWithQuery(url, query) {
        router.push({path: url, query: query})
    }

    function toWebsite(url) {
        window.open(url)
    }

    function goToGoogleMap(address) {
        const googleMapUrl = `https://www.google.com/maps?q=${encodeURIComponent(address)}`;
        window.open(googleMapUrl, '_blank');
    }

    function handelLoginBtn() {
        if (isMobile.value) {
            goToLogin()
        } else {
            settingStore.updateLoginDialogVisible(true)
        }
    }

    function goToLogin() {
        const loginPath = route.path.includes('new-') ? '/new-login' : '/login'
        go(loginPath)
    }

    function goToRegister() {
        const registerPath = route.path.includes('new-') ? '/new-register' : '/register'
        go(registerPath)
        settingStore.updateLoginDialogVisible(false)
    }

    function goToPhoneValidation() {
        const phoneValidationPath = route.path.includes('new-') ? '/new-phone-validation' : '/phone-validation'
        go(phoneValidationPath)
    }

    function goToSpacePage(spaceId: string) {
        const route = router.resolve({path: `/space/${spaceId}`})
        window.open(route.href, '_blank')
    }

    function serverGoHome() {
        // navigateTo({path: '/'})
        router.push({path: '/'})
    }

    return {
        goHome,
        go,
        goWithQuery,
        toWebsite,
        goToGoogleMap,
        handelLoginBtn,
        goToLogin,
        goToRegister,
        goToPhoneValidation,
        goToSpacePage,
        serverGoHome
    };
}
